import {Col, Form, Input, InputNumber, Row} from 'antd';
import {FormInstance} from 'antd/lib/form';
import React, {useEffect} from 'react';
import _ from "lodash";
import {isNotBlank} from "../../../../reducers/util";

interface Props {
    form: FormInstance
    fieldId: string
    text?: React.ReactNode
    minValue?: number
    minLabel?: string
    maxValue?: number
    maxLabel?: string
}

const getLabel = (min: any, max: any) => {
    let label = `${min} to ${max}`
    if ((_.isNil(min) || min === '') && max) {
        label = `Maximum ${max}`
    } else if (min && (_.isNil(max) || max === '')) {
        label = `Minimum ${min}`
    }
    return label
}

const MinMaxFilter = ({form, fieldId, text, minValue, minLabel, maxValue, maxLabel}: Props) => {

    const value = form.getFieldValue(fieldId)

    const onChange = (value: number | null) => {
        let min = form.getFieldValue('min') ?? ''
        let max = form.getFieldValue('max') ?? ''
        form.setFieldValue(fieldId, `${min},${max}`)
        form.setFieldValue(`${fieldId}_labels`, [getLabel(min, max)])
    }

    useEffect(() => {
        let initMin = undefined
        let initMax = undefined
        if (value) {
            initMin = value[0]
            initMax = value[1]
        }
        const initLabel = getLabel(initMin, initMax)

        form.setFieldsValue({
            min: initMin,
            max: initMax,
            [`${fieldId}_labels`]: initLabel,
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value])

    const minAndMaxAgeIsValid = (rule: any, value: any) => {
        const min = parseInt(form.getFieldValue('min'))
        const max = parseInt(form.getFieldValue('max'))
        if (isNotBlank(min) && isNotBlank(max) && min > max) {
            return Promise.reject('Minimum age cannot be after Maximum age.')
        } else {
            return Promise.resolve()
        }
    }

    return <>
        <Row>
            <Col span={24}>
                {text}
            </Col>
        </Row>
        <Row>
            <Form.Item name={fieldId} hidden={true}>
                <Input/>
            </Form.Item>
            <Form.Item name={`${fieldId}_labels`} hidden={true}>
                <Input/>
            </Form.Item>
            <Col span={12} style={{padding: "5px"}}>
                <Form.Item name={'min'} label={minLabel} rules={[{ validator: minAndMaxAgeIsValid }]}>
                    <InputNumber min={minValue} max={maxValue} onChange={onChange}/>
                </Form.Item>
            </Col>
            <Col span={12} style={{padding: "5px"}}>
                <Form.Item name={'max'} label={maxLabel} rules={[{ validator: minAndMaxAgeIsValid }]}>
                    <InputNumber min={minValue} max={maxValue} onChange={onChange}/>
                </Form.Item>
            </Col>
        </Row>
    </>

}

export default MinMaxFilter